import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AncillariesModalComponent } from './ancillaries-modal.component';
import { ModalModule } from '../modal/modal.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { FlightSpecialRequestsModule } from '../passengers/flight-special-requests/flight-special-requests.module';

@NgModule({
  declarations: [AncillariesModalComponent],
  imports: [CommonModule, ModalModule, SharedModule, FlightSpecialRequestsModule],
  exports: [AncillariesModalComponent]
})
export class AncillariesModalModule {}
